import * as React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
  useParams,
} from "react-router-dom";

import styled from "@material-ui/styles/styled";
import ThemeProvider from "@material-ui/styles/ThemeProvider";

import { theme as defaultTheme } from "./utils/Theme";
import { FirebasePageAnalytics } from "./utils/Analytics";
import { PageWrapper } from "./components/PageWrapper/PageWrapper";
import { Authenticator, FirebaseAuthenticator } from "./utils/Auth";
import IrisAssessmentPage from "./pages/IrisAssessmentPage";
import IrisEditorPage from "./pages/IrisEditorPage";

const AuthorPage = React.lazy(() => import("./pages/AuthorPage"));
const MarketingPage = React.lazy(() => import("./pages/MarketingPage"));
const ProductsPage = React.lazy(() => import("./pages/ProductsPage"));
const PublisherPage = React.lazy(() => import("./pages/PublisherPage"));
const ReportPage = React.lazy(() => import("./pages/ReportPage"));
const TrialPageEditors = React.lazy(() => import("./pages/TrialPageEditors"));
const TrialPage = React.lazy(() => import("./pages/TrialPage"));
const WebinarPage = React.lazy(() => import("./pages/WebinarPage"));
const TermsPage = React.lazy(() => import("./pages/TermsPage"));
const PrivacyPage = React.lazy(() => import("./pages/PrivacyPage"));
const RaiPage = React.lazy(() => import("./pages/RaiPage"));
const FaqPage = React.lazy(() => import("./pages/FaqPage"));
const TeamPage = React.lazy(() => import("./pages/TeamPage"));
const BusinessCardPage = React.lazy(() => import("./pages/BusinessCardPage"));
const CreateBusinessCardPage = React.lazy(() =>
  import("./pages/CreateBusinessCardPage")
);
const CompanyPage = React.lazy(() => import("./pages/CompanyPage"));
const PricingPage = React.lazy(() => import("./pages/PricingPage"));
const BlogPage = React.lazy(() => import("./pages/BlogPage"));

const Main = styled("div")({
  width: "100%",
  overflowX: "hidden",
  overflowY: "hidden",
});

class App extends React.Component<{}, {}> {
  // authenticator: Authenticator = new StubAuthenticator();
  authenticator: Authenticator = new FirebaseAuthenticator();

  componentDidMount() {
    this.authenticator.init();
  }

  public renderWithTheme(content: JSX.Element) {
    return <ThemeProvider theme={defaultTheme}>{content}</ThemeProvider>;
  }

  public render() {
    return (
      <ThemeProvider theme={defaultTheme}>{this.renderContent()}</ThemeProvider>
    );
  }

  private renderLoader() {
    return <PageWrapper />;
  }

  private renderContent() {
    return (
      <Router>
        <ScrollToTop />
        <FirebasePageAnalytics />
        <div className="App">
          <Main>
            <React.Suspense fallback={this.renderLoader()}>
              <Switch>
                <Route path="/home">
                  <MarketingPage />
                </Route>
                <Route path="/authors">
                  <AuthorPage />
                </Route>
                <Route path="/publishers">
                  <PublisherPage />
                </Route>
                <Route exact={true} path="/">
                  <MarketingPage />
                </Route>
                <Route path="/reports">
                  <ReportPage />
                </Route>
                <Route path="/author-trial">
                  <TrialPage
                    code="iris-trial-akb7"
                    endDate={new Date("2025-12-31")}
                  />
                </Route>
                <Route path="/nac">
                  <TrialPage
                    code="iris-trial-akb7"
                    endDate={new Date("2025-12-31")}
                  />
                </Route>
                <Route path="/author-trial-2024">
                  <TrialPage
                    code="iris-trial-akb7"
                    endDate={new Date("2025-12-31")}
                  />
                </Route>
                <Route path="/editor-trial">
                  <TrialPageEditors
                    code="iris-trial-akb7"
                    endDate={new Date("2025-12-31")}
                  />
                </Route>
                <Route path="/free-webinar">
                  <WebinarPage />
                </Route>
                <Route path="/iris">
                  <ProductsPage />
                </Route>
                <Route path="/assessment">
                  <IrisAssessmentPage />
                </Route>
                <Route path="/editor">
                  <IrisEditorPage />
                </Route>
                <Route path="/pricing">
                  <PricingPage />
                </Route>
                <Route path="/team">
                  <TeamPage />
                </Route>
                <Route path="/company">
                  <CompanyPage />
                </Route>
                <Route path="/rai">
                  <RaiPage />
                </Route>
                <Route path="/business-card">
                  <BusinessCardPage />
                </Route>
                <Route path="/create-business-card">
                  <CreateBusinessCardPage />
                </Route>
                <Route path="/faq">
                  <FaqPage />
                </Route>
                <Route path="/terms">
                  <TermsPage />
                </Route>
                <Route path="/privacy">
                  <PrivacyPage />
                </Route>
                <Route path="/blog/:slug?">
                  <Blog />
                </Route>
                <Route path="*">
                  <MarketingPage />
                </Route>
              </Switch>
            </React.Suspense>
          </Main>
        </div>
      </Router>
    );
  }
}

const Blog = () => {
  const { slug } = useParams<{ slug: string }>();
  return <BlogPage slug={slug} />;
};

const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx